import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { ViewUserAdminModel } from 'src/app/pages/User-Admin-Master/view-user-admin/view-user-admin.Models';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService ]
})
export class SidebarComponent implements OnInit {  
  viewUserAdminModelobj:ViewUserAdminModel=new ViewUserAdminModel();
  public settings: Settings;
  public menuItems:Array<any>;
  public menuItems5=[] as any;
  menuRoleList=[] as any;
  mur_role;
  constructor(public appSettings: AppSettings, public menuService: MenuService) {
    this.settings = this.appSettings.settings;
    //this.menuItems =this.menuService.getVerticalMenuItems();
    debugger
    console.log('localStorage',localStorage.getItem("menurolesList"))
    if(localStorage.getItem("menurolesList") !=null && localStorage.getItem("menurolesList") !=undefined ){
      debugger
      this.menuRoleList= JSON.parse(localStorage.getItem("menurolesList"));
      console.log('this.menuRoleList sidebar',this.menuRoleList)
      this.viewUserAdminModelobj.Ad_User_Type=this.mur_role;
      console.log('this.menuItems',this.menuItems)
      this.menuItems =this.menuService.getVerticalMenuItems(this.menuRoleList).filter(e => e.showMenu==true)
    }
    else
    {
      this.menuItems =this.menuService.getVerticalMenuItems(this.menuRoleList).filter(e => e.showMenu==true)
    }
  }

  ngOnInit() {     
    if(sessionStorage["userMenuItems"]) {
      debugger
      let ids = JSON.parse(sessionStorage.getItem("userMenuItems"));
      let newArr = [];
      ids.forEach(id => {
        let newMenuItem = this.menuItems.filter(mail => mail.id == id);
        newArr.push(newMenuItem[0]);
      });
      debugger
      this.menuItems = newArr; 
      console.log('this.menuItems',this.menuItems)
    }
  }

  public closeSubMenus(){
    debugger
    let menu = document.querySelector("#menu0");
    for (let i = 0; i < menu.children.length; i++) {
        let child = menu.children[i].children[1]; 
        if(child){
            if(child.classList.contains('show')){
              child.classList.remove('show');
              menu.children[i].children[0].classList.add('collapsed'); 
            }             
        }
    }
  }


}
